import { render, staticRenderFns } from "./lvNav.vue?vue&type=template&id=5b13e752&scoped=true&"
import script from "./lvNav.vue?vue&type=script&lang=js&"
export * from "./lvNav.vue?vue&type=script&lang=js&"
import style0 from "./lvNav.vue?vue&type=style&index=0&id=5b13e752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13e752",
  null
  
)

export default component.exports